import { FormLabel, Textarea } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../services/lang/lang';
import { ChipContainer } from '../Chip/ChipContainer';
import { Chip } from '../Chip/Chip';
import { ChipLabel } from '../Chip/ChipLabel';
import { ChipCloseButton } from '../Chip/ChipCloseButton';
export const MultiEmailInput = (props) => {
    const addEmailsFromEvent = (event) => {
        const trimmedEmails = event.currentTarget.value.trim();
        if (trimmedEmails.length > 0) {
            const emails = trimmedEmails.split(' ');
            props.onAdd(emails);
            event.currentTarget.value = '';
        }
    };
    const onTextAreaKeyDown = (event) => {
        if (event.key === 'Enter' && event.currentTarget.value.length > 0) {
            event.preventDefault();
            addEmailsFromEvent(event);
        }
    };
    const stagedEmailChips = props.emails.map((email) => (React.createElement(Chip, { key: email },
        React.createElement(ChipLabel, null, email),
        React.createElement(ChipCloseButton, { onClick: () => props.onRemove(email) }))));
    return (React.createElement(React.Fragment, null,
        React.createElement(FormLabel, { htmlFor: "invite-users-emails" }, localise('ENTER_EMAIL_ADDRESS_OF_TEAM_MEMBERS')),
        React.createElement(Textarea, { id: "invite-users-emails", variant: "primary", placeholder: localise('EXAMPLE_EMAIL'), onKeyDown: onTextAreaKeyDown, "data-testid": "multi-email-input", onBlur: addEmailsFromEvent }),
        React.createElement(ChipContainer, null, stagedEmailChips)));
};
